import * as React from 'react';

export type RadioButtonV2Props = Omit<
	React.InputHTMLAttributes<HTMLInputElement>,
	'type' | 'value'
> & {
	label: string;
	description?: string;
	value: string;
	disabled?: boolean;
	variant?: 'small' | 'large' | 'card';
};

const variants = {
	small: {
		label: 'mr-4',
		input: 'mr-2 mb-1',
	},
	large: {
		label: 'mr-4',
		input: 'mr-2 mb-1 w-6 h-6',
	},
	card: {
		label: 'border border-secondaryBorder rounded-sm p-3 text-md h-full',
		input: 'mr-2 mb-1 w-6 h-6',
	},
};

export const RadioButtonV2 = React.forwardRef<HTMLInputElement, RadioButtonV2Props>(
	({ label, description, value, variant = 'small', disabled = false, ...props }, ref) => (
		<label
			className={`${variants[variant].label} ${disabled ? 'opacity-25 cursor-not-allowed' : 'cursor-pointer'}`}
		>
			<input
				className={variants[variant].input}
				ref={ref}
				type='radio'
				value={value}
				disabled={disabled}
				{...props}
			/>
			{label}
			{description && (
				<span className='text-sm block pl-8 pt-1 text-tertiaryTextDark font-normal'>
					{description}
				</span>
			)}
		</label>
	)
);
